<div class="notes" *ngIf="notas?.notas">
  <div
    class="note {{ i }}"
    *ngFor="let nota of notas?.notas; let i = index"
    [ngClass]="{
      show:
        (notaType === 'ANOTACAO' && nota.concluido === true) ||
        (notaType === 'LEMBRETE' && nota.concluido === false)
    }"
  >
    <div class="note-head">
      <app-list-head
        [matIconName]="
          notaType === 'ANOTACAO' ? 'description' : 'circle_notifications'
        "
        [subTitle]="nota.data.toDate() | date"
        [title]="nota?.nome_vendedor_escritor?.split(' ').slice(0, 2).join(' ')"
      ></app-list-head>

      <div class="menu">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="deleteNota(i)">
            <mat-icon style="color: red">delete_forever</mat-icon>
            <span
              style="color: red; font-weight: bold"
              *ngIf="notaType === 'ANOTACAO'"
              >Excluir anotação</span
            >
            <span
              style="color: red; font-weight: bold"
              *ngIf="notaType === 'LEMBRETE'"
              >Excluir lembrete</span
            >
          </button>

          <button
            (click)="concludeNota(i)"
            mat-menu-item
            *ngIf="notaType === 'LEMBRETE'"
          >
            <mat-icon style="color: green">check_circle</mat-icon>
            <span style="color: green; font-weight: bold"
              >Concluir lembrete</span
            >
          </button>
        </mat-menu>
      </div>
    </div>

    <div *ngIf="nota.loja_vendedor_escritor" class="info">
      <app-mini-card
        [matIconName]="'storefront'"
        [text]="nota?.loja_vendedor_escritor"
        [backgroundColor]="'gray'"
        [textAndIconColor]="'white'"
        [borderColor]="'black'"
      ></app-mini-card>
    </div>

    <div
      class="info"
      *ngIf="nota.nome_vendedor_marcador && nota.data_conclusao"
    >
      <app-mini-card
        [matIconName]="'check_circle'"
        [text]="nota?.nome_vendedor_marcador?.split(' ').slice(0, 2).join(' ')"
        [textAndIconColor]="'black'"
        [backgroundColor]="'rgb(91, 208, 91)'"
        [borderColor]="'green'"
      ></app-mini-card>

      <app-mini-card
        [matIconName]="'event_available'"
        [text]="nota?.data_conclusao.toDate() | date : 'dd/MM/yyyy'"
        [textAndIconColor]="'black'"
        [backgroundColor]="'rgb(91, 208, 91)'"
        [borderColor]="'green'"
      ></app-mini-card>
    </div>

    <div class="note-body">{{ nota.texto }}</div>
  </div>
</div>
